<mat-table #table [dataSource]="items">
  <ng-container matColumnDef="line">
    <mat-header-cell *matHeaderCellDef> Número de Línea </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.line}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="notes">
    <mat-header-cell *matHeaderCellDef> Notas </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.notes}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <mat-header-cell *matHeaderCellDef> Cantidad </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.quantity}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="productDescription">
    <mat-header-cell *matHeaderCellDef> Producto </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.productDescription}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="publishDates">
    <mat-header-cell *matHeaderCellDef> Fechas de publicación </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <div *ngFor="let dt of element.publishDates">{{dt | date: 'MMM dd yyyy'}}</div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <a mat-icon-button routerLink="/digitar/{{orderid}}/{{element.line}}" matTooltip="Modificar" color="primary">
        <mat-icon aria-label="Editar">{{element.internalStatus === 'I'? 'create' : 'done'}}</mat-icon>
      </a>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
